import React from 'react';
import '../../../css/admin/chats/EventNotes.css';
import ChatNotesPanel from '../../common/chat/notes/ChatNotesPanel';

const API_URL = process.env.REACT_APP_API_URL;

const AdminPersonalNotesPanel = ({
  artistId,
  onModeChange,
  onNotesChanged,
  canCreateNote = true,
  canManageNotes = true,
}) => (
  <ChatNotesPanel
    ownerId={artistId}
    rootClassName="admin-notes-panel"
    title="ノート"
    buildListUrl={(ownerId, offset = 0, limit = 20) => `${API_URL}/api/admin/personal-chat-notes/${ownerId}?offset=${offset}&limit=${limit}`}
    createUrl={`${API_URL}/api/admin/personal-chat-notes`}
    buildUpdateUrl={(noteId) => `${API_URL}/api/admin/personal-chat-notes/${noteId}`}
    buildDeleteUrl={(noteId) => `${API_URL}/api/admin/personal-chat-notes/${noteId}`}
    buildDetailUrl={(noteId) => `${API_URL}/api/personal-chat-notes/detail/${noteId}`}
    onModeChange={onModeChange}
    onNotesChanged={onNotesChanged}
    canCreateNote={canCreateNote}
    canManageNotes={canManageNotes}
    openDetailEventName="admin-personal-notes-open-detail"
    closeDetailEventName="admin-personal-notes-close-detail"
    closeImageEventName="admin-personal-notes-close-image"
  />
);

export default AdminPersonalNotesPanel;
